import { useState } from 'react'
import { Prose } from '../../components/Prose'
import { bantBasamaklari, bantEtiketi } from '../../lib/bant'

/**
 * Elindeki direnç bantlarının kg listesi.
 *
 * Neden ayrı bir alan: bant, ağırlık takılan bir ekipman değil — yük, senin
 * sahip olduğun bantların kendisi ve kombinasyonları. Panel bunu bilmeden
 * "kaç kg" diye soramaz; sorsa kullanıcı ne yazacağını bilmez. Liste girilince
 * hem antrenman ekranında kg kutusu açılıyor hem ilerleme gerçek basamaklara
 * oturuyor: 15 ve 30 kg'lık iki bant → 15 / 30 / 45.
 */
export function BantAyari({ bandsKg, onKaydet }: {
  bandsKg: number[]
  onKaydet: (next: number[]) => void
}) {
  const [yeni, setYeni] = useState('')
  const sirali = [...bandsKg].sort((a, b) => a - b)
  const basamaklar = bantBasamaklari(sirali)

  const ekle = () => {
    const v = Math.round(Number(yeni.replace(',', '.')) * 10) / 10
    if (!Number.isFinite(v) || v <= 0 || v > 200) return
    if (sirali.some((x) => Math.abs(x - v) < 0.05)) { setYeni(''); return }
    onKaydet([...sirali, v].sort((a, b) => a - b))
    setYeni('')
  }

  return (
    <>
      <h3>Direnç bantların</h3>
      <Prose className="card-h">
        Bantlarının üstünde yazan kg değerlerini gir. Bunu bilmeden panel bant
        hareketlerinde yük soramıyor — girdiğin anda antrenman ekranında kg kutusu
        açılıyor ve ilerleme <strong>gerçekten kurabildiğin dirençler</strong> üzerinden
        gidiyor, uydurma bir yüzdeyle değil.
      </Prose>

      <div className="row" style={{ alignItems: 'flex-end' }}>
        <div style={{ flex: '0 1 160px' }}>
          <label className="f">Bant direnci (kg)</label>
          {/* aria-label şart: .f etiketi htmlFor kullanmıyor, yani ekran
              okuyucu ve testler alanı adıyla bulamıyordu. */}
          <input type="number" inputMode="decimal" min={1} max={200} step="0.5"
                 aria-label="Bant direnci (kg)"
                 value={yeni} placeholder="ör. 15"
                 onChange={(e) => setYeni(e.target.value)}
                 onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); ekle() } }} />
        </div>
        <button className="primary" onClick={ekle} disabled={!yeni.trim()}>
          Bandı ekle
        </button>
      </div>

      {sirali.length > 0 && (
        <div className="bantlar">
          {sirali.map((kg) => (
            <span className="pill bantpill" key={kg}>
              {kg.toLocaleString('tr-TR')} kg
              <button aria-label={`${kg} kg bandı sil`}
                      onClick={() => onKaydet(sirali.filter((x) => x !== kg))}>×</button>
            </span>
          ))}
        </div>
      )}

      {basamaklar.length > 0 && (
        <Prose className="note">
          Kurabildiğin dirençler:{' '}
          <strong>{basamaklar.map((b) => bantEtiketi(b, sirali)).join(' · ')}</strong>.
          {basamaklar.length > sirali.length
            && ' Birden fazla bandı aynı anda kullandığın varsayılıyor.'}
          {' '}Bandın üstündeki kg <em>tam gerdiğindeki</em> tepe direnç — bant gerildikçe
          sertleştiği için yük hareket boyunca sabit değil. Dambıl gibi kesin bir sayı
          değil ama "hangi bantla yaptım" bilgisi ilerlemeyi takip etmeye yetiyor.
        </Prose>
      )}
    </>
  )
}
